/**
 * Calculate the center-top position of an element for tooltip positioning
 * @param element - The target element
 * @returns Object with centerX and topY coordinates
 */
export const calculateCenterTopPosition = (element: HTMLElement) => {
  const rect = element.getBoundingClientRect();
  const centerX = rect.left + rect.width / 2;
  const topY = rect.top;
  return { centerX, topY };
};

/**
 * Calculate the right-center position of an element for tooltip positioning
 * @param element - The target element
 * @returns Object with rightX and centerY coordinates
 */
export const calculateRightCenterPosition = (element: HTMLElement) => {
  const rect = element.getBoundingClientRect();
  const rightX = rect.right;
  const centerY = rect.top + rect.height / 2;
  return { rightX, centerY };
};
